import { AnalyzeConstants } from '../../_constants/Analyze/analyze.constants';

const initialState = { role_user_FitmentLoading: true, role_user_FitmentData: {}, role_user_FitmentError: false };

export function role_user_FitmentReducer(state = initialState, action) {

    switch (action.type) {
        case AnalyzeConstants.REQUEST_FITMENTS_DATA:
            return {
                role_user_FitmentLoading: true,
                role_user_FitmentData: {},
                role_user_FitmentError: false
            };
        case AnalyzeConstants.RECEIVE_FITMENTS_DATA:
            return {
                role_user_FitmentLoading: false,
                role_user_FitmentData: action.res,
                role_user_FitmentError: false
            };
        case AnalyzeConstants.ERROR_FITMENTS_DATA:
            return {
                role_user_FitmentLoading: false,
                role_user_FitmentData: {},
                role_user_FitmentError: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/Analyze/role_fitment_user.reducer.js